<mat-card class="auth-block">
  <mat-card-content>
    <h1>Payment error</h1>
    <h4>{{error}}</h4>
  </mat-card-content>
</mat-card>